export default __webpack_public_path__ + "assets/images/88b5de4d4d20785484c6defb6ee3b3af.png";